import React from "react";
import { Button } from "../ui/Button";
import { ProductCarousel } from "../ui/ProductCarousel";

interface Hook2SectionProps {
  heading: string;
  productImages: string[];
  ctaText: string;
  onCtaClick: () => void;
}

export function Hook2Section({
  heading,
  productImages,
  ctaText,
  onCtaClick,
}: Hook2SectionProps) {
  return (
    <section className="bg-black py-20 px-4">
      <div className="w-full max-w-6xl mx-auto px-4">
        <div className="flex flex-col items-center text-center gap-8">
          {/* Heading */}
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-[#a79c68]">
            {heading}
          </h2>

          {/* Product Carousel */}
          <ProductCarousel images={productImages} />

          {/* CTA Button */}
          <div className="flex justify-center mt-6">
            <Button variant="primary" size="lg" onClick={onCtaClick}>
              {ctaText}
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
}
